export default __webpack_public_path__ + "static/social-card-6c6daadf762c9715beb2345513d9752a.png";